import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

import { AsyncLoaderControl } from "@/Common/Components/Loader/AsyncLoaderControl";
import { LoginAction } from "@/Common/Stores/Actions/LoginAction";

export function ClinicSettingsLoader(): JSX.Element {
    const [loadIsReady, setLoadIsReady] = useState<boolean>(false);

    useEffect(() => {
        new LoginAction().loadClinicSettings();

        const onCacheChange = (): void => {
            if (cacheStore.ClinicSettings) {
                setLoadIsReady(true);
            }
        };

        const eventId = cacheStore.AddChangeListener(onCacheChange, null, "ClinicSettingsLoader");

        return () => cacheStore.RemoveChangeListener(eventId);
    }, []);

    const isLoading = !loadIsReady || !cacheStore.ClinicSettings;

    if (isLoading)
        return <AsyncLoaderControl IsActive={isLoading} />;

    return <Outlet />;
}
